import React, { Component } from "react";
import { Descriptions, Avatar, Card, Spin, message } from "antd";
//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../redux/actions/actions";
//components
import DescriptionItem from "./Description";
import ActionTable from "./ActionTable";
import ThumbnailGrid from "./ThumbnailGrid";
import stylesheet from "./Main.module.css";

//antd
const { Meta } = Card;

class Main extends Component {
  constructor(props) {
    super(props);
    this.numberOfColumns = 4;
    this.state = { visible: true, onKeyboardCooldown: false };
  }

  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyDown);
  }

  getUser() {
    return (
      this.props.data.users &&
      this.props.data.users[this.props.data.profileIndex]
    );
  }

  _handleKeyDown = ({ keyCode }) => {
    // number 1
    const goodKey = 49;
    // Delete, escape, and number 2
    const badKeys = [46, 8, 50];

    const allKeys = [goodKey, ...badKeys];

    // Stop spamming!
    if (allKeys.includes(keyCode) && this.state.onKeyboardCooldown) {
      message.error("Please carefully review the profile");
      return;
    }

    // Handle good and bad keys
    if (keyCode === goodKey) {
      this.props.actions.submitProfile({ accepted: true });
      goodMessage(this.getUser()._id);
    } else if (badKeys.includes(keyCode)) {
      this.props.actions.submitProfile({ accepted: false });
      badMessage(this.getUser()._id);
    }

    // Set our keyboard cooldown period
    this.setState(() => ({ onKeyboardCooldown: true }));
    const KEYBOARD_COOLDOWN_MS = 1500;
    setTimeout(
      () => this.setState({ onKeyboardCooldown: false }),
      KEYBOARD_COOLDOWN_MS
    );
  };

  render() {
    const user =
      this.props.data.users &&
      this.props.data.users[this.props.data.profileIndex];

    if (!user) return <Spin style={styles.centered} size="large" />;
    return (
      <div key={user._id}>
        <Descriptions
          bordered
          style={{ marginBottom: "1%" }}
          column={this.numberOfColumns}
          title={<Title user={user} />}
          border
          size="small"
        />
        <ThumbnailGrid
          shortcodes={user.shortcodes}
          thumbnails={user.thumbnails}
          userId={user._id}
          batchId={user.batchId}
          refreshThumbnails={this.props.actions.refreshThumbnails}
        />
      </div>
    );
  }
}

const Title = props => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <Meta
      className={stylesheet.userMeta}
      avatar={
        <Avatar
          size={72}
          src={props.user.profilePic}
          style={{ marginRight: "12px" }}
        />
      }
      title={
        <a
          target="_blank"
          href={`https://instagram.com/${props.user._id}`}
          rel="noreferrer"
        >
          {props.user._id}
        </a>
      }
      description={
        <div style={styles.regularFont}>
          <span style={styles.bold}>{props.user.posts}</span> posts
          <span style={styles.followTextFormat}>
            {props.user.followers}
          </span>{" "}
          followers
          <span style={styles.followTextFormat}>{props.user.follows}</span>{" "}
          following
          <br />
          <br />
          <p style={styles.bold}>{props.user.fullName}</p>
          <p style={styles.regularFont}>{props.user.biography}</p>
        </div>
      }
    />
    <ActionTable userId={props.user._id} />
  </div>
);

const styles = {
  regularFont: {
    fontWeight: 300,
    fontSize: 14,
    color: "black",
  },
  bold: { fontWeight: 400 },
  followTextFormat: { fontWeight: 400, marginLeft: "12px" },
  centered: {
    //centered in the middle of screen
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
};

const mapStateToProps = state => {
  return {
    data: state.data, //access 'data' attribute of Redux state as this.props.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
  }; //bind actions from "./redux/actions/actions" to = this.prop.actions.<ACTION_FUNCTION>
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);

export function goodMessage(userId) {
  message.success(
    <>
      Marked <strong>{userId}</strong> as <strong>good</strong>
    </>,
    1
  );
}

export function badMessage(userId) {
  message.error(
    <>
      Marked <strong>{userId}</strong> as <strong>bad</strong>
    </>,
    1
  );
}
